import React from 'react';
import { Navigate } from 'react-router-dom';
import useMobxStoreHook from "../hooks/use-mobx-store.hook";
import {observer} from "mobx-react-lite";

const RequireUnauthorized = observer(({ children }) => {

    const {
        session: { isAuthenticated },
    } = useMobxStoreHook();

    if (isAuthenticated) {
      return <Navigate to="/purchases" replace />;
    }

    return children;
});

export default RequireUnauthorized;
